import React from 'react';
import { doodleCatalog } from '../../data/doodleShapes';
import type { BcmLeader } from '../../data/leadership';
const accents = ['bg-brand-blue', 'bg-brand-yellow', 'bg-brand-tan', 'bg-brand-pink'] as const;

/**
 * Every card gets a different supplied navy shape, which reads clearly on all
 * four light accent panels above.
 */
const cardShapes = [...doodleCatalog.navy.stars.slice(0, 6), ...doodleCatalog.navy.organics.slice(0, 6)];
function Shape({
  index
}: {
  index: number;
}) {
  return <img src={cardShapes[index % cardShapes.length]} alt="" aria-hidden="true" draggable={false} className="pointer-events-none h-9 w-9 object-contain" data-id="element-24" data-mp="2w724ozayw0ar" />;
}

/**
 * Branded role card. When `leader.photo` is supplied the real photo replaces the
 * initials placeholder — no stock headshots or generated faces are ever used.
 */
export function LeaderCard({
  leader,
  index
}: {
  leader: BcmLeader;
  index: number;
}) {
  return <article className="flex h-full flex-col overflow-hidden rounded-[20px] border-2 border-brand-navy bg-white transition-transform duration-200 hover:-translate-y-1" data-id="element-25" data-mp="lhlr4ej44q4b">
      {leader.photo ? <img src={leader.photo} alt={leader.photoAlt ?? `${leader.name}, ${leader.role} at UCF BCM`} loading="lazy" className="aspect-square w-full border-b-2 border-brand-navy object-cover object-center" data-id="element-26" data-mp="rvb95yvhiaij" /> : <div className={`flex aspect-square w-full flex-col items-center justify-center gap-2 border-b-2 border-brand-navy ${accents[index % accents.length]}`} data-id="element-27" data-mp="d0ohyjqqsjz0">
          <span aria-hidden="true" data-id="element-28" data-mp="4832pdmbkvex">
            <Shape index={index} data-id="element-29" data-mp="3vdusud03k81q" />
          </span>
          <span className="px-2 text-center font-meta text-[12.5px] font-semibold text-brand-navy" data-id="element-30" data-mp="3vf5tw525r1p5">
            Add Image here
          </span>
        </div>}
      <div className="p-5" data-id="element-31" data-mp="3lfyfdejot10g">
        <h3 className="font-display text-lg font-bold leading-snug text-brand-navy" data-id="element-32" data-mp="3lgq6od694ckx">
          {leader.name}
        </h3>
        <p className="mt-1 font-meta text-[12px] font-semibold uppercase tracking-[0.14em] text-ink" data-id="element-33" data-mp="3bqrjqoolicv7">
          {leader.role}
        </p>
      </div>
    </article>;
}